import React from "react";
import QuestionOptions from "../QuestionOptions";
import { BaseQuestionType } from "service/exercise";
import Form from "rc-field-form";
import { RuleObject, StoreValue } from "rc-field-form/es/interface";

interface FieldOptionsProps {
    queTypeId: BaseQuestionType;
    getError: (name: string) => any;
}

export default function FieldOptions({
    queTypeId,
    getError
}: FieldOptionsProps) {
    const initialOptions = [
        {
            key: Math.random(),
            isRight: queTypeId === BaseQuestionType.SingleChoice,
            description: ""
        }, // 单选题默认选中第一项
        { key: Math.random(), isRight: false, description: "" },
        { key: Math.random(), isRight: false, description: "" },
        { key: Math.random(), isRight: false, description: "" }
    ];

    // 校验选项内容
    function optionsValidator(rule: RuleObject, value: StoreValue) {
        return new Promise<void>((resolve, reject) => {
            let errors: any[] = [];

            for (let option of value) {
                if (option.description.trim() === "") {
                    errors.push({
                        key: option.key,
                        error: "选项必填，请填写选项后再提交保存"
                    });
                }
            }

            if (errors.length === 0) {
                resolve();
            } else {
                reject([errors]);
            }
        });
    }

    return (
        <Form.Field
            name="options"
            initialValue={initialOptions}
            rules={[{ validator: optionsValidator }]}>
            <QuestionOptions
                type={
                    queTypeId === BaseQuestionType.SingleChoice
                        ? "radio"
                        : "checkbox"
                }
                errors={getError("options")}
            />
        </Form.Field>
    );
}
